export const managerNewPaths = {
  turmas: '/gestor/gerenciar-turmas',
  turmaDetalhe: '/gestor/gerenciar-turmas/detalhe',
  participantes: '/gestor/gerenciar-participantes',
  questionarioSelecao: '/gestor/gerenciar-participantes/questionario-selecao',
  notasCce: '/gestor/gerenciar-participantes/notas-cce',
  configuracoes: '/gestor/gerenciar-configuracoes',
};

// Rota principal do sistema de gestão (destino pós-login).
export const managerNewMainRoute = `${managerNewPaths.participantes}?modulo=1`;
